export class GcpBigQueryResourceTablesInner {
    'name';
    'type';
    'storageBillingModel';
    'numRows';
    'totalLogicalBytes';
    'totalPhysicalBytes';
    'activeLogicalBytes';
    'longTermLogicalBytes';
    'activePhysicalBytes';
    'longTermPhysicalBytes';
    'timeTravelPhysicalBytes';
    'kmsKeyName';
    'creationTime';
    'lastModifiedTime';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageBillingModel",
            "baseName": "storageBillingModel",
            "type": "string",
            "format": ""
        },
        {
            "name": "numRows",
            "baseName": "numRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalLogicalBytes",
            "baseName": "totalLogicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalPhysicalBytes",
            "baseName": "totalPhysicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "activeLogicalBytes",
            "baseName": "activeLogicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "longTermLogicalBytes",
            "baseName": "longTermLogicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "activePhysicalBytes",
            "baseName": "activePhysicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "longTermPhysicalBytes",
            "baseName": "longTermPhysicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "timeTravelPhysicalBytes",
            "baseName": "timeTravelPhysicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "kmsKeyName",
            "baseName": "kmsKeyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "creationTime",
            "baseName": "creationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastModifiedTime",
            "baseName": "lastModifiedTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GcpBigQueryResourceTablesInner.attributeTypeMap;
    }
    constructor() {
    }
}
